import PropTypes from 'prop-types';
import { memo, useMemo, useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { sendReaction } from '../../../../utils';
import { getActionsEnabled } from '../../../../utils/commonActions';
import './ReactionCount.scss';
import { ReactionGridModal } from './ReactionsMenu';

export const ReactionCount = memo(({ channelId, messageId, reactions }) => {
   const [showReactionGrid, setShowReactionGrid] = useState(false);

   const reactionList = useMemo(() => {
      return Object.keys(reactions).length
         ? Object.entries(reactions)
              .sort((a, b) => b[1].count - a[1].count)
              .map(([emoji]) => emoji)
         : [];
   }, [reactions]);

   const cumulativeCount = useMemo(() => {
      return Object.values(reactions).reduce((acc, reaction) => acc + reaction.count, 0);
   }, [reactions]);

   const handleSendReaction = emoji => {
      const actionDisabled = getActionsEnabled(channelId);
      if (actionDisabled) return;
      sendReaction({ channelId, messageId, reaction: emoji });
      closeReactionGrid();
   };

   const toggleReactionGrid = () => {
      setShowReactionGrid(prev => !prev);
   };

   const closeReactionGrid = () => {
      setShowReactionGrid(false);
   };

   // Don't render anything if cumulative count is 0 or less
   if (cumulativeCount <= 0) {
      return null;
   }

   return (
      <OutsideClickHandler onOutsideClick={closeReactionGrid}>
         <div className="user-reactions-container">
            <button className="reaction-count-container" onClick={toggleReactionGrid}>
               {reactionList.slice(0, 3).map(emoji => (
                  <span key={emoji} className="reaction-emoji">
                     {emoji}
                  </span>
               ))}
               {cumulativeCount > 1 && <span className="reaction-count">{cumulativeCount}</span>}
            </button>
            {showReactionGrid && (
               <ReactionGridModal
                  reactions={reactions}
                  onSelectReaction={handleSendReaction}
                  closeReactionGrid={closeReactionGrid}
               />
            )}
         </div>
      </OutsideClickHandler>
   );
});

ReactionCount.propTypes = {
   channelId: PropTypes.string,
   messageId: PropTypes.string,
   reactions: PropTypes.object,
};
